/* Anyé Capital store prototype — interactions + store backbone (vanilla, dependency-free) */
(function () {
  'use strict';
  var DATA = window.ANYE || { products: [], collections: {}, byId: function(){}, byCollection: function(){return[];} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + Number(n).toLocaleString(); };
  var stars = function (r) { var f = Math.round(r || 5); return '★★★★★'.slice(0, f) + '☆☆☆☆☆'.slice(0, 5 - f); };

  /* ---------- indicator chart faces ---------- */
  function chartSVG(kind) {
    if (kind === 'gamma') return '<svg viewBox="0 0 300 120" preserveAspectRatio="none" fill="none"><path d="M0 90 L40 80 L70 95 L110 60 L150 70 L190 35 L230 50 L270 25 L300 32" stroke="#86cfa4" stroke-width="2.4"/><path d="M0 90 L40 80 L70 95 L110 60 L150 70 L190 35 L230 50 L270 25 L300 32 L300 120 L0 120 Z" fill="rgba(134,207,164,.12)"/><line x1="0" y1="45" x2="300" y2="45" stroke="#34563f" stroke-width="1" stroke-dasharray="4 5"/><line x1="0" y1="78" x2="300" y2="78" stroke="#34563f" stroke-width="1" stroke-dasharray="4 5"/></svg>';
    if (kind === 'fvg') return '<svg viewBox="0 0 300 120" preserveAspectRatio="none" fill="none"><rect x="60" y="40" width="240" height="20" fill="rgba(134,207,164,.14)"/><rect x="120" y="74" width="180" height="16" fill="rgba(95,158,120,.13)"/><path d="M0 100 L40 88 L80 96 L120 62 L160 74 L200 50 L240 64 L300 40" stroke="#cdd4c6" stroke-width="2.2"/></svg>';
    return '<svg viewBox="0 0 300 120" preserveAspectRatio="none" fill="none"><path d="M0 80 L50 70 L100 84 L150 50 L200 60 L250 30 L300 42" stroke="#86cfa4" stroke-width="2.2"/><path d="M0 95 L60 88 L120 92 L180 70 L240 78 L300 60" stroke="#b89bff" stroke-width="1.8" opacity=".7"/></svg>';
  }

  /* =========================================================
     PRODUCT ART — realistic material renders on studio backdrop
     True-to-life colors + form shading + soft contact shadows.
     ========================================================= */
  var _uid = 0;
  function uid(){ return 'a' + (_uid++); }
  function svg(defs, inner){ return '<svg viewBox="0 0 400 480" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg"><defs>' + defs + '</defs>' + inner + '</svg>'; }
  // warm greige studio backdrop (looks like a real product photo)
  function studio(refs){
    var g = uid(), hl = uid();
    refs.d += '<linearGradient id="' + g + '" x1="0" y1="0" x2="0" y2="480" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#efe9df"/><stop offset="1" stop-color="#d9d0c2"/></linearGradient>' +
      '<radialGradient id="' + hl + '" cx="50%" cy="32%" r="62%"><stop offset="0" stop-color="#f8f3ea"/><stop offset="1" stop-color="#f8f3ea" stop-opacity="0"/></radialGradient>';
    return '<rect width="400" height="480" fill="url(#' + g + ')"/><rect width="400" height="480" fill="url(#' + hl + ')"/>';
  }
  function contact(refs, cx, cy, rx, ry){
    var f = uid();
    refs.d += '<filter id="' + f + '" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="8"/></filter>';
    return '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + rx + '" ry="' + ry + '" fill="#6f6450" opacity=".42" filter="url(#' + f + ')"/>';
  }
  function grad(refs, x1,y1,x2,y2, c1, c2, c3){
    var id = uid();
    var stops = '<stop offset="0" stop-color="' + c1 + '"/>' + (c3 ? '<stop offset=".5" stop-color="' + c2 + '"/><stop offset="1" stop-color="' + c3 + '"/>' : '<stop offset="1" stop-color="' + c2 + '"/>');
    refs.d += '<linearGradient id="' + id + '" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" gradientUnits="userSpaceOnUse">' + stops + '</linearGradient>';
    return 'url(#' + id + ')';
  }

  /* ---- digital app (device on a desk) ---- */
  var UI = { win:'#15261b', bar:'#0f1c14', side:'#0c150f', cream:'#f3ece0', line:'#2f4d39', mint:'#86cfa4', card:'#1d3325', clay:'#d6a097', amber:'#e8c98a' };
  function appWindow(content){
    return '<rect x="62" y="58" width="276" height="326" rx="18" fill="' + UI.win + '" stroke="#23402e" stroke-width="1.5"/>' +
      '<path d="M62 76 a18 18 0 0 1 18 -18 h240 a18 18 0 0 1 18 18 v16 h-276 Z" fill="' + UI.bar + '"/>' +
      '<circle cx="86" cy="76" r="4.5" fill="' + UI.clay + '"/><circle cx="103" cy="76" r="4.5" fill="' + UI.amber + '"/><circle cx="120" cy="76" r="4.5" fill="' + UI.mint + '"/>' +
      '<path d="M62 92 h80 v274 a18 18 0 0 1 -18 18 h-44 a18 18 0 0 1 -18 -18 Z" fill="' + UI.side + '"/>' +
      '<text x="102" y="126" text-anchor="middle" font-family="Fraunces,serif" font-size="19" fill="' + UI.cream + '">Aé</text>' +
      '<rect x="78" y="150" width="48" height="7" rx="3.5" fill="' + UI.mint + '" opacity=".6"/>' +
      '<rect x="78" y="170" width="48" height="7" rx="3.5" fill="' + UI.cream + '" opacity=".16"/><rect x="78" y="190" width="48" height="7" rx="3.5" fill="' + UI.cream + '" opacity=".16"/><rect x="78" y="210" width="48" height="7" rx="3.5" fill="' + UI.cream + '" opacity=".16"/><rect x="78" y="230" width="48" height="7" rx="3.5" fill="' + UI.cream + '" opacity=".16"/>' +
      content;
  }
  function artApp(kind){
    var refs = { d:'' }, main;
    var area = grad(refs, 158,150,300,360, '#1f3627', '#16271c');
    if (kind === 'app-academy'){
      main = '<rect x="158" y="114" width="120" height="10" rx="5" fill="' + UI.cream + '" opacity=".85"/>' +
        '<rect x="158" y="138" width="158" height="68" rx="10" fill="' + area + '" stroke="' + UI.line + '"/>' +
        '<circle cx="186" cy="172" r="15" fill="' + UI.mint + '"/><path d="M181 165 l11 7 -11 7 Z" fill="' + UI.win + '"/>' +
        '<rect x="210" y="164" width="92" height="7" rx="3.5" fill="' + UI.cream + '" opacity=".6"/><rect x="210" y="178" width="62" height="6" rx="3" fill="' + UI.cream + '" opacity=".22"/>' +
        '<rect x="158" y="220" width="158" height="38" rx="9" fill="' + UI.card + '"/><rect x="158" y="266" width="158" height="38" rx="9" fill="' + UI.card + '"/><rect x="158" y="312" width="158" height="38" rx="9" fill="' + UI.card + '"/>' +
        '<circle cx="178" cy="239" r="9" fill="none" stroke="' + UI.mint + '" stroke-width="2.5"/><path d="M174 239 l3 3 6 -6" stroke="' + UI.mint + '" stroke-width="2" fill="none"/><circle cx="178" cy="285" r="9" fill="none" stroke="' + UI.cream + '" stroke-width="2.5" opacity=".3"/><circle cx="178" cy="331" r="9" fill="none" stroke="' + UI.cream + '" stroke-width="2.5" opacity=".3"/>';
    } else if (kind === 'app-stats'){
      var bg = grad(refs, 0,250,0,350, '#86cfa4', '#4f9e78');
      main = '<rect x="158" y="114" width="100" height="10" rx="5" fill="' + UI.cream + '" opacity=".85"/>' +
        '<text x="158" y="176" font-family="Fraunces,serif" font-size="44" fill="' + UI.cream + '">68%</text>' +
        '<rect x="158" y="190" width="84" height="7" rx="3.5" fill="' + UI.cream + '" opacity=".22"/>' +
        '<rect x="160" y="300" width="24" height="48" rx="4" fill="' + bg + '" opacity=".8"/><rect x="192" y="280" width="24" height="68" rx="4" fill="' + bg + '" opacity=".88"/><rect x="224" y="248" width="24" height="100" rx="4" fill="' + bg + '"/><rect x="256" y="286" width="24" height="62" rx="4" fill="' + bg + '" opacity=".88"/><rect x="288" y="266" width="24" height="82" rx="4" fill="' + bg + '" opacity=".8"/>';
    } else if (kind === 'app-discipline'){
      main = '<rect x="158" y="114" width="120" height="10" rx="5" fill="' + UI.cream + '" opacity=".85"/>';
      var op = [.22,.5,.92,.4,.75,.3,.6,.95,.5,.2,.82,.45,.65,.3,.9,.55,.25,.7,.4,.86,.5,.3,.95,.6,.4];
      for (var r=0;r<5;r++){ for (var cc=0;cc<5;cc++){ var ii=r*5+cc; main += '<rect x="' + (158+cc*31) + '" y="' + (148+r*31) + '" width="25" height="25" rx="6" fill="' + UI.mint + '" opacity="' + op[ii] + '"/>'; } }
      main += '<rect x="158" y="312" width="158" height="8" rx="4" fill="' + UI.cream + '" opacity=".16"/><rect x="158" y="332" width="112" height="8" rx="4" fill="' + UI.cream + '" opacity=".16"/>';
    } else {
      main = '<rect x="158" y="114" width="112" height="10" rx="5" fill="' + UI.cream + '" opacity=".85"/>' +
        '<rect x="158" y="134" width="64" height="7" rx="3.5" fill="' + UI.cream + '" opacity=".28"/>' +
        '<rect x="158" y="156" width="158" height="98" rx="10" fill="' + area + '" stroke="' + UI.line + '"/>' +
        '<path d="M172 232 L196 214 L214 224 L240 196 L266 206 L302 176" fill="none" stroke="' + UI.mint + '" stroke-width="2.6"/>' +
        '<path d="M172 232 L196 214 L214 224 L240 196 L266 206 L302 176 L302 244 L172 244 Z" fill="' + UI.mint + '" opacity=".14"/>' +
        '<rect x="158" y="266" width="75" height="48" rx="9" fill="' + UI.card + '"/><rect x="241" y="266" width="75" height="48" rx="9" fill="' + UI.card + '"/>' +
        '<rect x="170" y="278" width="34" height="6" rx="3" fill="' + UI.mint + '" opacity=".7"/><rect x="170" y="292" width="46" height="6" rx="3" fill="' + UI.cream + '" opacity=".22"/>' +
        '<rect x="253" y="278" width="34" height="6" rx="3" fill="' + UI.cream + '" opacity=".5"/><rect x="253" y="292" width="46" height="6" rx="3" fill="' + UI.cream + '" opacity=".22"/>' +
        '<rect x="158" y="326" width="158" height="8" rx="4" fill="' + UI.cream + '" opacity=".15"/>';
    }
    return svg(refs.d, studio(refs) + contact(refs, 200, 392, 132, 15) + appWindow(main));
  }

  /* ---- apparel ---- */
  function emFill(refs, x1,y1,x2,y2){ return grad(refs, x1,y1,x2,y2, '#315a40', '#244', '#18301f'); } // emerald knit
  function artGarment(hood){
    var refs = { d:'' };
    var body = emFill(refs, 120,170,300,376);
    var dark = '#1a3122';
    var sleeves = '<path d="M132 190 L72 216 Q66 220 68 230 L80 296 Q82 304 92 300 L132 284 Z" fill="' + body + '" stroke="#16291d" stroke-width="1"/>' +
                  '<path d="M268 190 L328 216 Q334 220 332 230 L320 296 Q318 304 308 300 L268 284 Z" fill="' + body + '" stroke="#16291d" stroke-width="1"/>';
    var torso = '<path d="M132 188 Q200 162 268 188 L268 358 Q268 376 250 376 L150 376 Q132 376 132 358 Z" fill="' + body + '" stroke="#16291d" stroke-width="1"/>';
    // soft folds + highlight
    var folds = '<path d="M168 230 Q176 300 172 366" stroke="' + dark + '" stroke-width="6" fill="none" opacity=".35" stroke-linecap="round"/>' +
                '<path d="M232 230 Q224 300 228 366" stroke="' + dark + '" stroke-width="6" fill="none" opacity=".35" stroke-linecap="round"/>' +
                '<path d="M150 210 Q150 290 156 360" stroke="#3f6b4c" stroke-width="5" fill="none" opacity=".4" stroke-linecap="round"/>';
    var neck, hoodEl = '';
    if (hood){
      hoodEl = '<path d="M150 184 Q200 116 250 184 Q224 210 200 212 Q176 210 150 184 Z" fill="' + grad(refs,150,120,250,210,'#234','#16291d') + '" stroke="#16291d" stroke-width="1"/>' +
        '<path d="M168 188 Q200 206 232 188" fill="none" stroke="#16291d" stroke-width="2" opacity=".5"/>' +
        '<path d="M190 202 L186 256" stroke="#efe7d8" stroke-width="3.6" stroke-linecap="round"/><path d="M210 202 L214 256" stroke="#efe7d8" stroke-width="3.6" stroke-linecap="round"/>' +
        '<rect x="183" y="254" width="6" height="10" rx="2" fill="#cbb487"/><rect x="211" y="254" width="6" height="10" rx="2" fill="#cbb487"/>';
      neck = '';
    } else {
      neck = '<path d="M170 182 Q200 200 230 182 L226 192 Q200 208 174 192 Z" fill="#16291d"/>' +
             '<path d="M170 182 Q200 200 230 182" fill="none" stroke="#3f6b4c" stroke-width="2" opacity=".5"/>';
    }
    var pocket = hood ? '<path d="M154 300 Q200 310 246 300 L246 342 Q200 360 154 342 Z" fill="none" stroke="#16291d" stroke-width="1.6" opacity=".7"/>' : '';
    var ribs = '';
    for (var i=0;i<26;i++){ ribs += '<line x1="' + (134+i*5.2) + '" y1="364" x2="' + (134+i*5.2) + '" y2="375" stroke="#16291d" stroke-width="1" opacity=".4"/>'; }
    // embroidered tonal monogram
    var crest = '<text x="200" y="270" text-anchor="middle" font-family="Fraunces,serif" font-size="22" fill="#3f6b4c" opacity=".9">Aé</text>';
    return svg(refs.d, studio(refs) + contact(refs, 200, 392, 120, 15) + sleeves + torso + folds + hoodEl + neck + pocket + ribs + crest);
  }
  function artCap(){
    var refs = { d:'' };
    var crown = grad(refs, 112,150,288,234, '#356046', '#1d3829');
    var brim = grad(refs, 120,234,280,278, '#27452f', '#152a1d');
    return svg(refs.d, studio(refs) + contact(refs, 204, 300, 96, 13) +
      '<path d="M112 232 Q112 150 200 150 Q288 150 288 232 Q200 246 112 232 Z" fill="' + crown + '" stroke="#16291d" stroke-width="1"/>' +
      '<path d="M118 232 Q200 250 282 232 Q284 256 200 280 Q116 256 118 232 Z" fill="' + brim + '" stroke="#16291d" stroke-width="1"/>' +
      '<path d="M200 152 Q198 196 200 232" stroke="#1a3122" stroke-width="1.5" opacity=".5" fill="none"/>' +
      '<path d="M162 158 Q156 198 152 230" stroke="#1a3122" stroke-width="1.5" opacity=".5" fill="none"/>' +
      '<path d="M238 158 Q244 198 248 230" stroke="#1a3122" stroke-width="1.5" opacity=".5" fill="none"/>' +
      '<path d="M118 232 Q200 250 282 232" stroke="#3f6b4c" stroke-width="1.5" opacity=".4" fill="none"/>' +
      '<circle cx="200" cy="152" r="4.5" fill="#1a3122"/>' +
      '<text x="200" y="210" text-anchor="middle" font-family="Fraunces,serif" font-size="22" fill="#cbb487">Aé</text>');
  }
  function artTote(){
    var refs = { d:'' };
    var canvas = grad(refs, 112,170,288,384, '#e7d9bb', '#cdbb95');
    var strap = '#b49a6f';
    return svg(refs.d, studio(refs) + contact(refs, 200, 404, 116, 14) +
      '<path d="M150 178 Q156 110 200 110 Q244 110 250 178" fill="none" stroke="' + strap + '" stroke-width="9" stroke-linecap="round"/>' +
      '<path d="M150 178 Q156 110 200 110 Q244 110 250 178" fill="none" stroke="#a08a62" stroke-width="2" stroke-linecap="round" opacity=".5"/>' +
      '<rect x="110" y="172" width="180" height="214" rx="8" fill="' + canvas + '" stroke="#c2ad86" stroke-width="1.5"/>' +
      '<path d="M120 176 Q120 280 124 382" stroke="#c2ad86" stroke-width="4" opacity=".4" fill="none"/>' +
      '<rect x="110" y="172" width="180" height="214" rx="8" fill="none" stroke="#b89f78" stroke-width="1" stroke-dasharray="2 5" opacity=".7"/>' +
      '<text x="200" y="296" text-anchor="middle" font-family="Fraunces,serif" font-size="42" fill="#1f3a2a">Aé</text>' +
      '<text x="200" y="324" text-anchor="middle" font-family="Inter,sans-serif" font-size="10" letter-spacing="3.5" fill="#1f3a2a" opacity=".6">ROOTED</text>');
  }
  /* ---- home ---- */
  function artCandle(){
    var refs = { d:'' };
    var glass = grad(refs, 140,196,260,376, '#d9b98a', '#a9824f');
    var wax = grad(refs, 150,206,250,240, '#f3e7cd', '#e3d2ac');
    return svg(refs.d, studio(refs) + contact(refs, 200, 392, 80, 13) +
      '<ellipse cx="200" cy="170" rx="40" ry="40" fill="#f2c879" opacity=".35" filter=""/>' +
      '<path d="M200 150 Q211 169 200 184 Q189 169 200 150 Z" fill="#f4b24a"/><path d="M200 161 Q206 171 200 181 Q195 171 200 161 Z" fill="#fff3da"/>' +
      '<path d="M200 184 L200 198" stroke="#4a3a24" stroke-width="2.5"/>' +
      '<path d="M140 210 Q140 200 152 200 L248 200 Q260 200 260 210 L260 360 Q260 376 244 376 L156 376 Q140 376 140 360 Z" fill="' + glass + '" opacity=".55"/>' +
      '<ellipse cx="200" cy="202" rx="58" ry="11" fill="#caa264"/><ellipse cx="200" cy="200" rx="50" ry="8" fill="' + wax + '"/>' +
      '<rect x="158" y="262" width="84" height="76" rx="6" fill="#f3ece0"/><rect x="158" y="262" width="84" height="76" rx="6" fill="none" stroke="#d8cdb8"/>' +
      '<text x="200" y="298" text-anchor="middle" font-family="Fraunces,serif" font-size="22" fill="#1f3a2a">Aé</text>' +
      '<text x="200" y="318" text-anchor="middle" font-family="Inter,sans-serif" font-size="8" letter-spacing="2.5" fill="#1f3a2a" opacity=".6">MARKET OPEN</text>' +
      '<rect x="156" y="214" width="10" height="150" rx="5" fill="#fff" opacity=".18"/>');
  }
  function artBook(){
    var refs = { d:'' };
    var linen = grad(refs, 118,150,284,366, '#ddd2bb', '#c3b596');
    return svg(refs.d, studio(refs) + contact(refs, 196, 392, 110, 14) +
      '<polygon points="280,156 298,168 298,372 280,360" fill="#efe7d4"/><polygon points="280,156 298,168 298,372 280,360" fill="none" stroke="#cdbf9f"/>' +
      '<rect x="288" y="170" width="6" height="196" fill="#d8cbac" opacity=".7"/>' +
      '<rect x="116" y="150" width="168" height="214" rx="7" fill="' + linen + '" stroke="#b8a980" stroke-width="1"/>' +
      '<rect x="116" y="150" width="14" height="214" rx="7" fill="#16291d" opacity=".0"/>' +
      '<rect x="132" y="166" width="136" height="182" rx="4" fill="none" stroke="#1f3a2a" stroke-width="1" opacity=".35"/>' +
      '<rect x="246" y="150" width="10" height="214" fill="#1f3a2a" opacity=".85"/>' +
      '<text x="192" y="262" text-anchor="middle" font-family="Fraunces,serif" font-size="34" fill="#1f3a2a">Aé</text>' +
      '<text x="192" y="288" text-anchor="middle" font-family="Inter,sans-serif" font-size="9" letter-spacing="2.5" fill="#1f3a2a" opacity=".7">THE JOURNAL</text>' +
      '<rect x="189" y="360" width="14" height="32" rx="2" fill="#c98a78"/>');
  }
  function artDeskmat(){
    var refs = { d:'' };
    var mat = grad(refs, 60,250,342,360, '#2c4d38', '#18301f');
    return svg(refs.d, studio(refs) + contact(refs, 200, 388, 150, 14) +
      '<polygon points="92,248 308,248 344,362 56,362" fill="' + mat + '" stroke="#16291d" stroke-width="1"/>' +
      '<polygon points="106,256 294,256 326,354 74,354" fill="none" stroke="#e8dcc4" stroke-width="1.2" stroke-dasharray="3 5" opacity=".45"/>' +
      '<rect x="150" y="276" width="46" height="80" rx="8" fill="#0f1c14" transform="rotate(-7 173 316)"/>' +
      '<rect x="160" y="286" width="26" height="58" rx="4" fill="#1f3627" transform="rotate(-7 173 315)"/>' +
      '<rect x="214" y="300" width="96" height="12" rx="6" fill="#cbb487" transform="rotate(-7 262 306)"/>' +
      '<text x="118" y="340" font-family="Fraunces,serif" font-size="16" fill="#cbb487" opacity=".55">Aé</text>');
  }
  function artPrints(){
    var refs = { d:'' };
    function frame(x,y,w,h,word){
      var art = grad(refs, x,y,x,y+h, '#2c4d38', '#18301f');
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3" fill="#efe7d4" stroke="#cdbf9f"/>' +
        '<rect x="' + (x+9) + '" y="' + (y+9) + '" width="' + (w-18) + '" height="' + (h-18) + '" fill="#f3ece0"/>' +
        '<rect x="' + (x+20) + '" y="' + (y+20) + '" width="' + (w-40) + '" height="' + (h-40) + '" fill="' + art + '"/>' +
        '<text x="' + (x+w/2) + '" y="' + (y+h/2+5) + '" text-anchor="middle" font-family="Fraunces,serif" font-style="italic" font-size="14" fill="#f3ece0">' + word + '</text>';
    }
    return svg(refs.d, studio(refs) + contact(refs, 200, 384, 140, 12) + frame(68,176,110,196,'Faith') + frame(146,148,108,224,'Discipline') + frame(222,182,110,184,'Clarity'));
  }
  function artClipboard(){
    var refs = { d:'' }, rows = '';
    for (var i=0;i<5;i++){ var y=208+i*30; rows += '<rect x="146" y="' + y + '" width="18" height="18" rx="5" fill="' + (i<3?'#86cfa4':'#fff') + '" stroke="#cdbf9f" stroke-width="1.4"/>' + (i<3?'<path d="M150 '+(y+9)+' l4 5 8 -10" stroke="#15261b" stroke-width="2" fill="none"/>':'') + '<rect x="176" y="' + (y+5) + '" width="' + (98-i*9) + '" height="7" rx="3.5" fill="#cdbf9f"/>'; }
    return svg(refs.d, studio(refs) + contact(refs, 200, 392, 96, 13) +
      '<rect x="118" y="158" width="164" height="222" rx="10" fill="#f5efe4" stroke="#d8cdb8" stroke-width="1.5"/>' +
      '<rect x="176" y="148" width="48" height="22" rx="6" fill="#1f3627"/><rect x="192" y="142" width="16" height="10" rx="3" fill="#16291d"/>' +
      '<text x="200" y="196" text-anchor="middle" font-family="Fraunces,serif" font-size="16" fill="#1f3a2a">Pre-Trade Checklist</text>' + rows);
  }
  function artPlanner(){
    var refs = { d:'' }, grid='';
    for (var c=0;c<5;c++){ grid += '<line x1="' + (212+c*22) + '" y1="208" x2="' + (212+c*22) + '" y2="348" stroke="#d8cdb8" stroke-width="1"/>'; }
    for (var r=0;r<6;r++){ grid += '<line x1="208" y1="' + (216+r*24) + '" x2="312" y2="' + (216+r*24) + '" stroke="#d8cdb8" stroke-width="1"/>'; }
    return svg(refs.d, studio(refs) + contact(refs, 200, 388, 118, 14) +
      '<rect x="90" y="172" width="220" height="192" rx="6" fill="#f5efe4" stroke="#d8cdb8" stroke-width="1.5"/>' +
      '<line x1="200" y1="172" x2="200" y2="364" stroke="#d8cdb8" stroke-width="1.5"/>' +
      '<rect x="108" y="194" width="74" height="9" rx="4" fill="#1f3a2a" opacity=".75"/>' +
      '<rect x="108" y="216" width="76" height="6" rx="3" fill="#d8cdb8"/><rect x="108" y="234" width="76" height="6" rx="3" fill="#d8cdb8"/><rect x="108" y="252" width="60" height="6" rx="3" fill="#d8cdb8"/><rect x="108" y="270" width="76" height="6" rx="3" fill="#d8cdb8"/><rect x="108" y="288" width="50" height="6" rx="3" fill="#86cfa4" opacity=".7"/>' +
      '<rect x="208" y="186" width="60" height="9" rx="4" fill="#1f3a2a" opacity=".75"/>' + grid);
  }
  function artCrest(){
    var refs = { d:'' };
    return svg(refs.d, studio(refs) + contact(refs, 200, 320, 70, 12) +
      '<circle cx="200" cy="210" r="60" fill="#1f3a2a"/><circle cx="200" cy="210" r="60" fill="none" stroke="#16291d"/>' +
      '<text x="200" y="226" text-anchor="middle" font-family="Fraunces,serif" font-size="40" fill="#f3ece0">Aé</text>' +
      '<text x="200" y="306" text-anchor="middle" font-family="Inter,sans-serif" font-size="11" letter-spacing="4" fill="#6f6450">ANYÉ CAPITAL</text>');
  }
  function artSVG(kind){
    switch (kind){
      case 'app': return artApp('app');
      case 'app-academy': return artApp('app-academy');
      case 'app-stats': return artApp('app-stats');
      case 'app-discipline': return artApp('app-discipline');
      case 'hoodie': return artGarment(true);
      case 'crew': return artGarment(false);
      case 'cap': return artCap();
      case 'tote': return artTote();
      case 'candle': return artCandle();
      case 'book': return artBook();
      case 'deskmat': return artDeskmat();
      case 'prints': return artPrints();
      case 'toolkit': return artClipboard();
      case 'planner': return artPlanner();
      default: return artCrest();
    }
  }

  /* ---------- product card ---------- */
  function phTile(name, cap) {
    return '<div class="ph-in"><span class="ph-ring">Aé</span><b class="ph-name">' + (name || 'Anyé Capital') + '</b><span class="ph-cap">' + (cap || 'Photography coming soon') + '</span></div>';
  }
  function productMedia(p) {
    if (p.image) return '<img class="pimg" src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">';
    return phTile(p.title);
  }
  function cardMedia(p) {
    if (p.type === 'indicator') {
      if (p.image) return '<div class="mock ph"><img class="pimg" src="' + p.image + '" alt="' + p.title + '" loading="lazy"></div>';
      return '<div class="mock indi-media"><div class="glow"></div><span class="tf">' + p.tf + '</span><span class="pv">' + p.note + '</span><div class="chart">' + chartSVG(p.chart) + '</div></div>';
    }
    return '<div class="mock ph">' + productMedia(p) + '</div>';
  }
  function genCard(p) {
    var ribbon = p.soon ? '<span class="ribbon soon">Coming soon</span>' : (p.badge ? '<span class="ribbon">' + p.badge + '</span>' : '');
    var qv = '<button class="qv-btn" data-qv="' + p.id + '" aria-label="Quick view"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="11" cy="11" r="7"/><path d="m20 20-3-3"/></svg></button>';
    var quick = '<div class="quick">' + (p.soon
      ? '<a class="btn ghost sm" href="#notify" data-notify>Notify me</a>'
      : '<button class="btn mint sm" data-add data-id="' + p.id + '">Add to cart</button>') + qv + '</div>';
    var heart = '<button class="wish' + (wish.has(p.id) ? ' on' : '') + '" data-wish="' + p.id + '" aria-label="Save"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 20s-7-4.3-7-9.3A3.7 3.7 0 0 1 12 7a3.7 3.7 0 0 1 7 3.7C19 15.7 12 20 12 20Z"/></svg></button>';
    var ratingLine = p.soon
      ? '<div class="stars" style="color:var(--muted2)">Be the first to know</div>'
      : '<div class="stars">' + stars(p.rating) + ' <span>(' + p.reviews + ')</span></div>';
    var price = '<div class="pr">' + money(p.price) + (p.compareAt ? ' <small>' + money(p.compareAt) + '</small>' : '') + '</div>';
    var hasPage = p.url && p.url !== '#';
    var view = '<a href="' + (p.url || '#') + '" class="btn ghost sm">View</a>';
    var title = hasPage ? '<a href="' + p.url + '" class="pcard-title">' + p.title + '</a>' : p.title;
    var media = hasPage ? '<a href="' + p.url + '" class="media-link">' + cardMedia(p) + '</a>' : cardMedia(p);
    return '<article class="card pcard hover reveal" data-id="' + p.id + '">' +
      '<div class="media">' + ribbon + heart + media + quick + '</div>' +
      '<div class="pbody"><span class="tier">' + p.tier + '</span><h4>' + title + '</h4><p>' + p.blurb + '</p>' +
      ratingLine + '<div class="pfoot">' + price + view + '</div></div></article>';
  }

  /* =========================================================
     CART
     ========================================================= */
  var GOAL = 75; // unlock the Weekly Planner free at $75
  var cart = [];
  try { cart = JSON.parse(localStorage.getItem('anye-cart') || '[]'); } catch (e) { cart = []; }
  var wish; try { wish = new Set(JSON.parse(localStorage.getItem('anye-wish') || '[]')); } catch (e) { wish = new Set(); }
  function saveWish() { try { localStorage.setItem('anye-wish', JSON.stringify(Array.from(wish))); } catch (e) {} }
  function saveCart() { try { localStorage.setItem('anye-cart', JSON.stringify(cart)); } catch (e) {} }
  function cartCount() { return cart.reduce(function (n, i) { return n + i.qty; }, 0); }
  function cartSubtotal() { return cart.reduce(function (n, i) { return n + i.price * i.qty; }, 0); }
  var SHOP = !!window.ANYE_SHOPIFY;
  function shopFetch(u, b) { return fetch(u, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(b) }); }

  function addToCart(id, opts) {
    opts = opts || {};
    if (SHOP) {
      var _v = opts.shopVariant || (window.ANYE_VARIANTS && window.ANYE_VARIANTS[id]);
      if (!_v || _v === 'null') { console.warn('[Anye] no variant id for', id); alert('Sorry — this item isn’t available to add right now. Please refresh and try again.'); return; }
      var _qtyEl = document.querySelector('.qty-row .stepper input');
      var _qty = opts.qty || (_qtyEl ? Math.max(1, Number(_qtyEl.value) || 1) : 1);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(_v), quantity: _qty }] }) })
        .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || 'Add to cart failed'); }); } return r.json(); })
        .then(function () { renderCart(); openCart(); })
        .catch(function (err) { console.error('[Anye] add to cart failed:', err); alert('Sorry — we couldn’t add that to your cart. ' + (err && err.message ? err.message : 'Please try again.')); });
      return;
    }
    var p = DATA.byId(id);
    if (!p) return;
    var variant = opts.variant || null;
    var price = opts.price != null ? opts.price : p.price;
    var qty = opts.qty || 1;
    var key = id + '|' + (variant || '');
    var existing = cart.filter(function (i) { return i.key === key; })[0];
    if (existing) existing.qty += qty;
    else cart.push({ key: key, id: id, title: p.title, crest: p.crest || 'Aé', variant: variant, price: price, qty: qty });
    saveCart(); renderCart(); openCart();
  }
  function setQty(key, q) {
    if (SHOP) { shopFetch("/cart/change.js", { id: key, quantity: q }).then(function () { renderCart(); }); return; }
    var it = cart.filter(function (i) { return i.key === key; })[0];
    if (!it) return;
    it.qty = q;
    if (it.qty <= 0) cart = cart.filter(function (i) { return i.key !== key; });
    saveCart(); renderCart();
  }
  function removeItem(key) { if (SHOP) { shopFetch("/cart/change.js", { id: key, quantity: 0 }).then(function () { renderCart(); }); return; } cart = cart.filter(function (i) { return i.key !== key; }); saveCart(); renderCart(); }

  function buildCartDOM() {
    if ($('.cart')) return;
    var el = document.createElement('div');
    el.className = 'cart';
    el.innerHTML =
      '<div class="scrim" data-close-cart></div>' +
      '<aside class="cart-panel">' +
        '<div class="cart-head"><h4>Your bag <span class="n cart-n">0</span></h4>' +
          '<button class="icon-btn" data-close-cart aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
        '<div class="cart-progress"><div class="lab"></div><div class="track"><div class="fill"></div></div></div>' +
        '<div class="cart-items"></div>' +
        '<div class="cart-cross"></div>' +
        '<div class="cart-foot">' +
          '<div class="sub"><span>Subtotal</span><b class="cart-sub">$0</b></div>' +
          '<div class="ship">Taxes calculated at checkout · digital items deliver instantly</div>' +
          '<button class="btn mint lg block" data-checkout>Checkout</button>' +
          '<div class="trust-line"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg> Secure, encrypted checkout · 14-day guarantee</div>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(el);
    $$('[data-close-cart]', el).forEach(function (b) { b.addEventListener('click', closeCart); });
    $('[data-checkout]', el).addEventListener('click', function () {
      if (SHOP) { window.location.href = '/checkout'; return; }
      if (!cart.length) { closeCart(); return; }
      this.textContent = 'Connecting to secure checkout…';
      var self = this;
      setTimeout(function () { self.innerHTML = 'Checkout goes live on Shopify ✦'; }, 1100);
    });
  }
  function openCart() { buildCartDOM(); $('.cart').classList.add('open'); document.body.style.overflow = 'hidden'; if (SHOP) renderShopCart(); }
  function closeCart() { var c = $('.cart'); if (c) c.classList.remove('open'); document.body.style.overflow = ''; }

  var cartFetchSeq = 0;
  function renderShopCart() {
    buildCartDOM();
    var seq = ++cartFetchSeq;
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      if (seq !== cartFetchSeq) return; // a newer /cart.js request has since been issued — this response is stale, discard it
      var n = c.item_count, sub = c.total_price / 100;
      $$(".cart-count").forEach(function (x) { x.textContent = n; x.style.display = n ? "grid" : "none"; });
      var nn = $(".cart-n"); if (nn) nn.textContent = n;
      var cs = $(".cart-sub"); if (cs) cs.textContent = money(sub);
      var prog = $(".cart-progress");
      if (prog) { var lab = prog.querySelector(".lab"), fill = prog.querySelector(".fill"); if (sub >= GOAL) { lab.innerHTML = "\u2726 You\u2019ve unlocked the <b>Weekly Planner free</b> at checkout"; fill.style.width = "100%"; } else if (sub > 0) { lab.innerHTML = "You\u2019re <b>" + money(GOAL - sub) + "</b> away from a free Weekly Planner"; fill.style.width = (sub / GOAL * 100) + "%"; } else { lab.innerHTML = "Spend <b>" + money(GOAL) + "</b> and the Weekly Planner is on us"; fill.style.width = "0%"; } }
      var box = $(".cart-items");
      if (!c.items.length) { box.innerHTML = '<div class="cart-empty"><p>Your bag is empty</p><span class="muted" style="font-size:.88rem">Beautiful things are one tap away.</span></div>'; }
      else { box.innerHTML = c.items.map(function (i) { return '<div class="citem"><div class="thumb">' + (i.image ? '<img src="' + i.image + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:inherit">' : "A\u00e9") + '</div><div class="ci"><b>' + i.product_title + '</b><div class="row"><div class="qs"><button data-q="-" data-key="' + i.key + '">\u2212</button><span>' + i.quantity + '</span><button data-q="+" data-key="' + i.key + '">+</button></div><div class="pr">' + money(i.final_line_price / 100) + '</div></div></div><button class="rm" data-rm="' + i.key + '">Remove</button></div>'; }).join("");
        $$("[data-q]", box).forEach(function (b) { b.addEventListener("click", function () { var key = b.getAttribute("data-key"); var span = b.parentNode.querySelector("span"); var cur = parseInt(span.textContent, 10) || 0; setQty(key, cur + (b.getAttribute("data-q") === "+" ? 1 : -1)); }); });
        $$("[data-rm]", box).forEach(function (b) { b.addEventListener("click", function () { removeItem(b.getAttribute("data-rm")); }); }); }
      var cross = $(".cart-cross"); if (cross) { cross.style.display = "none"; cross.innerHTML = ""; }
    }).catch(function (err) { console.error('[Anye] cart render failed:', err); });
  }
  function renderCart() {
    if (SHOP) { renderShopCart(); return; }
    buildCartDOM();
    var n = cartCount(), sub = cartSubtotal();
    $$('.cart-count').forEach(function (c) { c.textContent = n; c.style.display = n ? 'grid' : 'none'; });
    $('.cart-n').textContent = n;
    $('.cart-sub').textContent = money(sub);

    // progress to unlock
    var prog = $('.cart-progress');
    if (sub >= GOAL) {
      prog.querySelector('.lab').innerHTML = '✦ You’ve unlocked the <b>Weekly Planner free</b> at checkout';
      prog.querySelector('.fill').style.width = '100%';
    } else if (sub > 0) {
      prog.querySelector('.lab').innerHTML = 'You’re <b>' + money(GOAL - sub) + '</b> away from a free Weekly Planner';
      prog.querySelector('.fill').style.width = (sub / GOAL * 100) + '%';
    } else {
      prog.querySelector('.lab').innerHTML = 'Spend <b>' + money(GOAL) + '</b> and the Weekly Planner is on us';
      prog.querySelector('.fill').style.width = '0%';
    }

    var box = $('.cart-items');
    if (!cart.length) {
      box.innerHTML = '<div class="cart-empty"><div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" style="width:26px;height:26px"><path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg></div><p>Your bag is empty</p><span class="muted" style="font-size:.88rem">Beautiful things are one tap away.</span></div>';
    } else {
      box.innerHTML = cart.map(function (i) {
        return '<div class="citem"><div class="thumb">' + (i.crest || 'Aé') + '</div>' +
          '<div class="ci"><b>' + i.title + '</b>' + (i.variant ? '<span class="var">' + i.variant + '</span>' : '') +
          '<div class="row"><div class="qs"><button data-q="-" data-key="' + i.key + '">−</button><span>' + i.qty + '</span><button data-q="+" data-key="' + i.key + '">+</button></div>' +
          '<div class="pr">' + money(i.price * i.qty) + '</div></div></div>' +
          '<button class="rm" data-rm="' + i.key + '">Remove</button></div>';
      }).join('');
      $$('[data-q]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var it = cart.filter(function (x) { return x.key === b.getAttribute('data-key'); })[0];
          if (!it) return;
          setQty(it.key, it.qty + (b.getAttribute('data-q') === '+' ? 1 : -1));
        });
      });
      $$('[data-rm]', box).forEach(function (b) { b.addEventListener('click', function () { removeItem(b.getAttribute('data-rm')); }); });
    }

    // cross-sell: up to 2 available products not already in cart
    var inCart = cart.map(function (i) { return i.id; });
    var recs = DATA.products.filter(function (p) { return !p.soon && inCart.indexOf(p.id) === -1; }).slice(0, 2);
    var cross = $('.cart-cross');
    if (cart.length && recs.length) {
      cross.style.display = 'block';
      cross.innerHTML = '<h6>You might also love</h6>' + recs.map(function (p) {
        return '<div class="cross-row"><div class="thumb">' + (p.crest || 'Aé') + '</div><div class="cx"><b>' + p.title + '</b><span>' + money(p.price) + '</span></div><button data-add data-id="' + p.id + '">Add</button></div>';
      }).join('');
      wireAdd(cross);
    } else { cross.style.display = 'none'; cross.innerHTML = ''; }
  }

  /* wire any [data-add] within a scope */
  function wireAdd(scope) {
    $$('[data-add]', scope).forEach(function (b) {
      if (b.__wired) return; b.__wired = true;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var id = b.getAttribute('data-id');
        var opts = {};
        opts.shopVariant = b.getAttribute('data-variant');
        // PDP context: pull selected variant + qty + live price
        if (b.hasAttribute('data-pdp')) {
          var v = $('.variant.active');
          if (v) { opts.variant = v.querySelector('b').textContent; opts.price = Number(v.getAttribute('data-price')); }
          var qi = $('.stepper input'); if (qi) opts.qty = parseInt(qi.value, 10) || 1;
        }
        if (id) addToCart(id, opts);
        var orig = b.getAttribute('data-label') || b.textContent;
        b.textContent = '✓ Added';
        setTimeout(function () { b.textContent = orig; }, 1300);
      });
    });
  }

  /* =========================================================
     MEGA-MENU
     ========================================================= */
  function buildMega() {
    if ($('.mega')) return;
    var cols = Object.keys(DATA.collections).map(function (slug) {
      var c = DATA.collections[slug];
      var items = DATA.byCollection(slug).slice(0, 4).map(function (p) {
        var href = (p.url && p.url !== '#') ? p.url : '/pages/shop';
        return '<a href="' + href + '"><span class="mdot"></span>' + p.title + '<small>' + (p.soon ? 'soon' : money(p.price)) + '</small></a>';
      }).join('');
      var colHref = slug === 'indicators' ? '/pages/indicators' : '/pages/shop';
      return '<div class="mega-col"><h6><a href="' + colHref + '">' + c.title + '</a></h6>' + items + '</div>';
    }).join('');
    var feat = DATA.byId('journal');
    var el = document.createElement('div');
    el.className = 'mega';
    el.innerHTML = '<div class="wrap"><div class="mega-inner"><div class="mega-cols">' + cols + '</div>' +
      '<div class="mega-feature"><span class="eyebrow">Most loved</span>' +
      '<div class="fc"><div class="mock"><div class="mock-glow"></div><div class="mock-crest"><div class="ring" style="width:46px;height:46px"><b style="font-size:1.1rem">Aé</b></div></div></div>' +
      '<div><h5>' + feat.title + '</h5><p>' + feat.blurb + '</p></div></div>' +
      '<a href="/products/the-journal" class="btn mint sm">Shop the Journal</a></div></div></div>';
    document.body.appendChild(el);

    var mega = el, hideT;
    function show() { clearTimeout(hideT); var h = $('header.site'); mega.style.paddingTop = (h ? h.getBoundingClientRect().bottom : 110) + 'px'; mega.classList.add('open'); }
    function hide() { hideT = setTimeout(function () { mega.classList.remove('open'); }, 160); }
    // triggers: nav links pointing at shop
    $$('.nav-links a').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (/shop/i.test(a.textContent) || /shop\.html/.test(href)) {
        a.classList.add('has-mega');
        a.addEventListener('mouseenter', show);
        a.addEventListener('mouseleave', hide);
        a.addEventListener('focus', show);
      }
    });
    mega.addEventListener('mouseenter', function () { clearTimeout(hideT); });
    mega.addEventListener('mouseleave', hide);
  }

  /* =========================================================
     PAGE RENDERERS
     ========================================================= */
  var PH_LABELS = { 'app':"The Beginner's Journal", 'app-academy':'The Academy', 'app-stats':'Your Stats', 'app-discipline':'Discipline Tracker' };
  function fillArtPlaceholders() {
    $$('.mock[data-art]').forEach(function (m) {
      if (m.__art) return; m.__art = true;
      m.classList.add('ph');
      var k = m.getAttribute('data-art');
      m.innerHTML = phTile(PH_LABELS[k] || 'Anyé Capital', m.getAttribute('data-cap') || 'Photography coming soon');
    });
  }
  function renderHome() {
    var d = $('#homeDigital'); if (d) { d.innerHTML = DATA.byCollection('digital').map(genCard).join(''); }
    var ind = $('#homeIndi'); if (ind) { ind.innerHTML = DATA.byCollection('indicators').map(genCard).join(''); }
    var m = $('#homeMerch');
    if (m) {
      var picks = ['hoodie', 'crew', 'book', 'candle'].map(function (id) { return DATA.byId(id); }).filter(Boolean);
      m.innerHTML = picks.map(genCard).join('');
    }
    if (d || ind || m) {
      wireAdd($('#homeDigital') || document); wireAdd($('#homeIndi') || document); wireAdd($('#homeMerch') || document);
      $$('#homeMerch [data-notify], #homeIndi [data-notify]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); location.href = '/pages/community'; }); });
      observeReveals();
    }
  }
  function renderFeaturedRow() {
    var host = $('#featuredRow'); if (!host) return;
    var top = DATA.products.filter(function (p) { return !p.soon; })
      .sort(function (a, b) { return (b.reviews || 0) - (a.reviews || 0); }).slice(0, 3);
    host.innerHTML = top.map(genCard).join('');
    wireAdd(host); observeReveals();
  }
  function renderShopIndex() {
    var host = $('#collectionsIndex'); if (!host) return;
    host.innerHTML = Object.keys(DATA.collections).map(function (slug) {
      var c = DATA.collections[slug];
      var avail = DATA.byCollection(slug).filter(function (p) { return !p.soon; }).length;
      var total = DATA.byCollection(slug).length;
      return '<a class="colcard reveal" href="/pages/shop">' +
        '<span class="count">' + total + ' items</span>' +
        '<div class="ct"><span class="eyebrow">' + c.eyebrow + '</span><h3>' + c.title + '</h3><p>' + c.blurb + '</p>' +
        '<span class="go">' + (avail ? 'Shop now' : 'Join the waitlist') + ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span></div></a>';
    }).join('');
    observeReveals();
  }

  function renderIndiGrid() {
    var host = $('#indiGrid'); if (!host) return;
    host.innerHTML = DATA.byCollection('indicators').map(genCard).join('');
    wireAdd(host);
    $$('[data-notify]', host).forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); location.href = '/pages/community'; }); });
    observeReveals();
  }

  function renderIndicator() {
    var host = $('#indiPdp'); if (!host) return;
    var params = new URLSearchParams(location.search);
    var p = DATA.byId(params.get('id'));
    if (!p || p.type !== 'indicator') p = DATA.byId('gamma');
    document.title = p.title + ' — Anyé Capital';

    var set = function (sel, val) { var el = $(sel); if (el) el.textContent = val; };
    set('#indiCrumb', p.title);
    set('#indiTier', p.tier);
    set('#indiTitle', p.title);
    set('#indiTagline', p.tagline || p.blurb);
    set('#indiBlurb', p.blurb);
    set('#indiStars', stars(p.rating));
    set('#indiReviews', p.rating + ' · ' + p.reviews + ' reviews');
    $$('[data-live-price]').forEach(function (el) { el.textContent = p.price; });
    var was = $('#indiWas'); if (was) { if (p.compareAt) { was.textContent = money(p.compareAt); was.style.display = ''; } else was.style.display = 'none'; }

    // big chart
    if ($('#indiChart')) $('#indiChart').innerHTML = chartSVG(p.chart);
    set('#indiTf', p.tf); set('#indiPv', p.note);

    // features → inside cards
    if ($('#indiFeatures') && p.features) {
      $('#indiFeatures').innerHTML = p.features.map(function (f) {
        return '<div class="card inside hover reveal"><div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 13l4 4L19 7"/></svg></div><h4>' + f.h + '</h4><p>' + f.p + '</p></div>';
      }).join('');
    }
    // includes
    if ($('#indiIncludes') && p.includes) {
      $('#indiIncludes').innerHTML = p.includes.map(function (i) {
        return '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 13l4 4L19 7"/></svg>' + i + '</li>';
      }).join('');
    }

    // buy buttons (main + mobile sticky)
    set('#indiCrumbMob', p.title);
    ['#indiAdd', '#indiAddMob'].forEach(function (sel) {
      var addBtn = $(sel); if (!addBtn) return;
      if (p.soon) {
        addBtn.textContent = 'Join the waitlist';
        addBtn.removeAttribute('data-add');
        addBtn.addEventListener('click', function (e) { e.preventDefault(); location.href = '/pages/community'; });
      } else {
        addBtn.setAttribute('data-id', p.id);
        var lbl = sel === '#indiAddMob' ? 'Add to cart' : 'Add to cart — ' + money(p.price);
        addBtn.setAttribute('data-label', lbl);
        addBtn.textContent = lbl;
      }
    });
    // related indicators
    if ($('#indiRelated')) {
      $('#indiRelated').innerHTML = DATA.byCollection('indicators').filter(function (x) { return x.id !== p.id; }).map(genCard).join('');
      wireAdd($('#indiRelated'));
      $$('#indiRelated [data-notify]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); location.href = '/pages/community'; }); });
    }
    observeReveals();
  }

  /* ---------- academy ---------- */
  var CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  function postCard(a) {
    return '<a class="card post hover reveal" href="/pages/academy">' +
      '<div class="ptop"><span class="pcat">' + a.cat + '</span><h3>' + a.title + '</h3></div>' +
      '<p>' + a.excerpt + '</p>' +
      '<div class="pmeta"><span class="read">' + CLOCK + a.read + ' read</span><span class="arrow">Read →</span></div></a>';
  }
  function renderBlocks(body) {
    return (body || []).map(function (b) {
      if (b.h2 != null) return '<h2>' + b.h2 + '</h2>';
      if (b.h3 != null) return '<h3>' + b.h3 + '</h3>';
      if (b.p != null) return '<p>' + b.p + '</p>';
      if (b.ul) return '<ul>' + b.ul.map(function (li) { return '<li>' + li + '</li>'; }).join('') + '</ul>';
      if (b.tip != null) return '<div class="callout"><b>Tip — </b>' + b.tip + '</div>';
      if (b.quote != null) return '<blockquote>' + b.quote + '</blockquote>';
      return '';
    }).join('');
  }
  function renderAcademy() {
    var feat = $('#academyFeature'), grid = $('#academyGrid');
    if (!feat && !grid) return;
    var arts = DATA.articles || [];
    if (feat && arts[0]) {
      var a = arts[0];
      feat.innerHTML = '<div class="af-copy"><span class="pcat">Featured · ' + a.cat + '</span>' +
        '<h2>' + a.title + '</h2><p>' + a.excerpt + '</p>' +
        '<div><a href="/pages/academy" class="btn mint">Read the article <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:1em;height:1em"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></div></div>' +
        '<div class="af-art"><div class="crest"><b>Aé</b><span>The Academy</span></div></div>';
    }
    if (grid) {
      grid.innerHTML = arts.slice(feat ? 1 : 0).map(postCard).join('');
    }
    observeReveals();
  }
  function renderArticle() {
    var host = $('#articleBody'); if (!host) return;
    var id = new URLSearchParams(location.search).get('id');
    var a = DATA.articleById(id) || DATA.articles[0];
    if (!a) return;
    document.title = a.title + ' — Anyé Capital';
    var set = function (sel, val) { var el = $(sel); if (el) el.textContent = val; };
    set('#articleCat', a.cat);
    set('#articleTitle', a.title);
    if ($('#articleMeta')) $('#articleMeta').innerHTML = '<span>' + a.read + ' read</span><span>·</span><span>' + a.date + '</span>';
    host.innerHTML = renderBlocks(a.body);
    var rel = $('#articleRel');
    if (rel) rel.innerHTML = DATA.articles.filter(function (x) { return x.id !== a.id; }).slice(0, 3).map(postCard).join('');
    observeReveals();
  }

  /* ---------- quiz: what kind of trader are you? ---------- */
  var ARCH = {
    seedling: { name: 'The Seedling', emoji: '🌱', sub: 'You’re at the most exciting part — the very beginning. Curious, open, and ready to build the right foundation from day one.', traits: ['Curious', 'Open', 'Eager to learn'], rec: 'journal' },
    architect: { name: 'The Architect', emoji: '📐', sub: 'You crave systems and structure. Give you the right tools and your discipline quietly becomes your edge.', traits: ['Disciplined', 'Methodical', 'Consistent'], rec: 'starter-kit' },
    phoenix: { name: 'The Phoenix', emoji: '🔥', sub: 'You’ve had real setbacks — and you’re rising with intention. This is your fresh, faith-rooted start.', traits: ['Resilient', 'Honest', 'Determined'], rec: 'risk-toolkit' },
    strategist: { name: 'The Strategist', emoji: '♟️', sub: 'Analytical and sharp. You know the basics cold — now you want the edge that separates good from great.', traits: ['Analytical', 'Sharp', 'Focused'], rec: 'starter-kit' }
  };
  var QZ = [
    { q: 'How long have you been trading?', opts: [['Just starting out', 'seedling'], ['A few months in', 'architect'], ['A year or more', 'strategist'], ['I’ve had real ups & downs', 'phoenix']] },
    { q: 'What trips you up the most?', opts: [['I don’t know where to start', 'seedling'], ['I don’t have a system', 'architect'], ['I get emotional & revenge-trade', 'phoenix'], ['I have a system but want an edge', 'strategist']] },
    { q: 'Your ideal trading morning is…', opts: [['Learning something new', 'seedling'], ['Running my checklist', 'architect'], ['Journaling & prayer', 'phoenix'], ['Analyzing levels & data', 'strategist']] },
    { q: 'What do you want most right now?', opts: [['Confidence to begin', 'seedling'], ['Consistency', 'architect'], ['A fresh start', 'phoenix'], ['Sharper entries', 'strategist']] },
    { q: 'Pick the word that feels most like you.', opts: [['Curious', 'seedling'], ['Disciplined', 'architect'], ['Resilient', 'phoenix'], ['Analytical', 'strategist']] }
  ];
  var QZ_ANS = [];
  function qzDots(i) { var s = ''; for (var d = 0; d < QZ.length; d++) s += '<span class="' + (d <= i ? 'on' : '') + '"></span>'; return '<div class="quiz-prog">' + s + '</div>'; }
  function renderQuiz() { var host = $('#quizApp'); if (!host) return; quizIntro(host); }
  function quizIntro(host) {
    host.innerHTML = '<div class="quiz-card quiz-intro reveal"><div class="qi-ico">🌿</div><span class="r-kick">60-second quiz</span><h1>What kind of<br>trader are you?</h1><p>Answer 5 quick questions and we’ll reveal your trader type — plus the perfect first step for you.</p><button class="btn mint lg" data-qz-start>Start the quiz <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:1em;height:1em"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button></div>';
    host.querySelector('[data-qz-start]').onclick = function () { QZ_ANS = []; quizStep(host, 0); };
    observeReveals();
  }
  function quizStep(host, i) {
    if (i >= QZ.length) { quizResult(host); return; }
    var q = QZ[i];
    host.innerHTML = '<div class="quiz-card reveal">' + qzDots(i) + '<div class="quiz-step"><span class="kq">Question ' + (i + 1) + ' of ' + QZ.length + '</span><h2>' + q.q + '</h2><div class="quiz-opts">' +
      q.opts.map(function (o, idx) { return '<button class="quiz-opt" data-i="' + idx + '">' + o[0] + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>'; }).join('') +
      '</div>' + (i > 0 ? '<button class="quiz-back">← back</button>' : '') + '</div></div>';
    $$('[data-i]', host).forEach(function (b) { b.addEventListener('click', function () { QZ_ANS[i] = q.opts[+b.getAttribute('data-i')][1]; quizStep(host, i + 1); window.scrollTo({ top: 0, behavior: 'smooth' }); }); });
    var bk = host.querySelector('.quiz-back'); if (bk) bk.addEventListener('click', function () { quizStep(host, i - 1); });
    observeReveals();
  }
  function quizResult(host) {
    var tally = {};
    QZ_ANS.forEach(function (k) { tally[k] = (tally[k] || 0) + 1; });
    var best = 'seedling', max = -1;
    ['seedling', 'architect', 'phoenix', 'strategist'].forEach(function (k) { if ((tally[k] || 0) > max) { max = tally[k] || 0; best = k; } });
    var a = ARCH[best], p = DATA.byId(a.rec) || DATA.byId('journal');
    var purl = (p && p.url && p.url !== '#') ? p.url : '/pages/shop';
    var pimg = p && p.image ? '<img src="' + p.image + '" alt="">' : '<div class="ph-mini">Aé</div>';
    host.innerHTML = '<div class="quiz-card quiz-result reveal"><div class="r-ico">' + a.emoji + '</div>' +
      '<span class="r-kick">You are</span><div class="r-name">' + a.name + '</div><p class="r-sub">' + a.sub + '</p>' +
      '<div class="quiz-traits">' + a.traits.map(function (t) { return '<span>' + t + '</span>'; }).join('') + '</div>' +
      '<div class="quiz-rec"><div class="qr-img">' + pimg + '</div><div class="qr-info"><span class="k">Your perfect first step</span><b>' + p.title + '</b><span>' + p.blurb + '</span></div></div>' +
      '<div class="quiz-actions"><a href="' + purl + '" class="btn mint lg block">Start with ' + p.title + ' →</a>' +
      '<div class="ghost-row"><a href="/pages/community" class="btn ghost">Join the Discord</a><button class="btn ghost" data-qz-share>Share result</button></div>' +
      '<button class="quiz-back" data-qz-retake style="margin:6px auto 0">↺ Retake the quiz</button></div></div>';
    host.querySelector('[data-qz-retake]').onclick = function () { quizIntro(host); window.scrollTo({ top: 0, behavior: 'smooth' }); };
    host.querySelector('[data-qz-share]').onclick = function () {
      var txt = 'I’m ' + a.name + ' ' + a.emoji + ' — what kind of trader are you? Take the Anyé quiz:';
      var url = location.href;
      if (navigator.share) { navigator.share({ title: 'Anyé Trader Quiz', text: txt, url: url }).catch(function () {}); }
      else { try { navigator.clipboard.writeText(txt + ' ' + url); var b = host.querySelector('[data-qz-share]'); b.textContent = 'Link copied ✓'; } catch (e) {} }
    };
    observeReveals();
  }

  var colState = { sort: 'featured', filter: 'all', slug: null };
  function renderCollection() {
    var host = $('#collectionGrid'); if (!host) return;
    var params = new URLSearchParams(location.search);
    var slug = params.get('c'); if (!DATA.collections[slug]) slug = 'digital';
    colState.slug = slug;
    var c = DATA.collections[slug];
    // hero
    if ($('#colEyebrow')) $('#colEyebrow').textContent = c.eyebrow;
    if ($('#colTitle')) $('#colTitle').textContent = c.title;
    if ($('#colBlurb')) $('#colBlurb').textContent = c.blurb;
    if ($('#colCrumb')) $('#colCrumb').textContent = c.title;
    $$('.col-other a').forEach(function (a) { a.classList.toggle('active', a.getAttribute('href').indexOf('c=' + slug) > -1); });
    document.title = c.title + ' — Anyé Capital';
    paintCollection();

    $$('.col-filters button').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.col-filters button').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active'); colState.filter = b.getAttribute('data-filter'); paintCollection();
      });
    });
    var sel = $('#colSort');
    if (sel) sel.addEventListener('change', function () { colState.sort = sel.value; paintCollection(); });
  }
  function paintCollection() {
    var host = $('#collectionGrid');
    var list = DATA.byCollection(colState.slug).slice();
    if (colState.filter === 'available') list = list.filter(function (p) { return !p.soon; });
    if (colState.filter === 'soon') list = list.filter(function (p) { return p.soon; });
    if (colState.sort === 'low') list.sort(function (a, b) { return a.price - b.price; });
    if (colState.sort === 'high') list.sort(function (a, b) { return b.price - a.price; });
    if (colState.sort === 'rated') list.sort(function (a, b) { return (b.rating || 0) - (a.rating || 0); });
    host.innerHTML = list.map(genCard).join('') || '<p class="muted" style="grid-column:1/-1;text-align:center;padding:40px">Nothing here yet — join the list to be first.</p>';
    if ($('#colCount')) $('#colCount').textContent = list.length + (list.length === 1 ? ' item' : ' items');
    wireAdd(host);
    $$('[data-notify]', host).forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); location.href = '/#discord'; }); });
    observeReveals();
  }

  /* =========================================================
     STANDARD INTERACTIONS
     ========================================================= */
  function initInteractions() {
    var header = $('header.site');
    var heroArt = $('.home-hero-bg .art');
    var docEl = document.documentElement;
    function onScroll() {
      var y = window.scrollY;
      if (header) header.classList.toggle('scrolled', y > 12);
      var sb = $('.sticky-buy'), anchor = $('#buybox-anchor');
      if (sb && anchor) sb.classList.toggle('show', anchor.getBoundingClientRect().bottom < 0);
      var bar = $('.scrollbar');
      if (bar) { var max = docEl.scrollHeight - docEl.clientHeight; bar.style.width = (max > 0 ? (y / max * 100) : 0) + '%'; }
      if (heroArt && !REDUCED) heroArt.style.transform = 'translateY(' + (y * 0.12) + 'px)';
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    var drawer = $('.drawer');
    $$('[data-open-nav]').forEach(function (b) { b.addEventListener('click', function () { if (drawer) drawer.classList.add('open'); }); });
    $$('[data-close-nav]').forEach(function (b) { b.addEventListener('click', function () { if (drawer) drawer.classList.remove('open'); }); });

    // cart open triggers (cart icon buttons)
    $$('.icon-btn[aria-label="Cart"]').forEach(function (b) { b.addEventListener('click', openCart); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeLightbox(); closeQV(); closePopup(); if (drawer) drawer.classList.remove('open'); } });

    // email popup triggers: scroll depth (once) + exit-intent
    if (!popSeen() && !window.ANYE_LANDING) {
      var popTry = function () {
        if (popSeen()) return;
        var max = docEl.scrollHeight - docEl.clientHeight;
        if (window.scrollY > 600 && max > 0 && window.scrollY > max * 0.4) openPopup();
      };
      window.addEventListener('scroll', popTry, { passive: true });
      document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0 && !REDUCED) openPopup(); });
    }

    // lightbox: click any product screenshot to enlarge
    document.addEventListener('click', function (e) {
      var img = e.target.closest('.gallery .main .mock.active img.pimg, .showcase-hero img, .showcase-fig .shot img');
      if (img && img.src) openLightbox(img.src, img.getAttribute('alt') || '');
    });

    // wishlist heart + quick-view (delegated, works on rendered cards)
    document.addEventListener('click', function (e) {
      var w = e.target.closest('[data-wish]');
      if (w) { e.preventDefault(); e.stopPropagation(); var id = w.getAttribute('data-wish');
        if (wish.has(id)) { wish.delete(id); w.classList.remove('on'); } else { wish.add(id); w.classList.add('on'); }
        saveWish(); return; }
      var q = e.target.closest('[data-qv]');
      if (q) { e.preventDefault(); openQuickView(q.getAttribute('data-qv')); }
    });

    // gallery
    var thumbs = $$('.thumb'), slides = $$('.gallery .main .mock');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-i');
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        slides.forEach(function (s) { s.classList.toggle('active', s.getAttribute('data-i') === i); });
        t.classList.add('active');
      });
    });

    // variants
    var variants = $$('.variant');
    variants.forEach(function (v) {
      v.addEventListener('click', function () {
        variants.forEach(function (x) { x.classList.remove('active'); });
        v.classList.add('active');
        var price = v.getAttribute('data-price');
        if (price) $$('[data-live-price]').forEach(function (el) { el.textContent = price; });
      });
    });

    // stepper
    $$('.stepper').forEach(function (s) {
      var input = s.querySelector('input');
      var dec = s.querySelector('[data-dec]'), inc = s.querySelector('[data-inc]');
      if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });

    // FAQ
    $$('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item'), a = item.querySelector('.faq-a');
        var open = item.classList.toggle('open');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      });
    });

    // email capture
    $$('[data-capture]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        f.innerHTML = '<p style="color:var(--up);font-family:var(--serif);font-size:1.15rem">You’re in. Welcome to the circle. \u{1F33F}</p>';
      });
    });

    // contact form
    $$('[data-contact]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var host = f.closest('.card') || f;
        host.innerHTML = '<div class="form-done"><div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" style="width:28px;height:28px"><path d="M5 13l4 4L19 7"/></svg></div><h3>Message sent 🤍</h3><p class="muted">Thank you for reaching out. We read every message and will get back to you within one business day.</p></div>';
      });
    });

    wireAdd(document);
  }

  /* scroll reveal */
  var io;
  function observeReveals() {
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    $$('.reveal:not(.in)').forEach(function (el) {
      if (!el.__stag) {
        el.__stag = true;
        try {
          var sibs = el.parentElement ? Array.prototype.slice.call(el.parentElement.querySelectorAll(':scope > .reveal')) : [];
          var idx = sibs.indexOf(el);
          if (idx > 0) el.style.transitionDelay = (Math.min(idx, 6) * 0.07) + 's';
        } catch (e) {}
      }
      io.observe(el);
    });
    setupTilt();
  }

  /* ---------- lightbox ---------- */
  function buildLightbox() {
    if ($('.lightbox')) return;
    var el = document.createElement('div');
    el.className = 'lightbox';
    el.innerHTML = '<button class="lb-close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6 6 18"/></svg></button><img alt=""><div class="lb-cap"></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('.lb-close')) closeLightbox(); });
  }
  function openLightbox(src, cap) {
    buildLightbox();
    var lb = $('.lightbox');
    lb.querySelector('img').src = src;
    lb.querySelector('.lb-cap').textContent = cap || '';
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    var lb = $('.lightbox');
    if (lb) { lb.classList.remove('open'); document.body.style.overflow = ''; }
  }

  /* ---------- quick view ---------- */
  function buildQV() {
    if ($('.qv')) return;
    var el = document.createElement('div');
    el.className = 'qv';
    el.innerHTML = '<div class="qv-panel"><button class="qv-close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="qv-media"></div><div class="qv-info"></div></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('.qv-close')) closeQV(); });
  }
  function openQuickView(id) {
    var p = DATA.byId(id); if (!p) return;
    buildQV();
    var qv = $('.qv');
    qv.querySelector('.qv-media').innerHTML = cardMedia(p);
    var ratingLine = p.soon ? '' : '<div class="stars">' + stars(p.rating) + ' <span style="color:var(--muted2);font-size:.8rem">(' + p.reviews + ' reviews)</span></div>';
    var priceLine = '<div class="pr">' + (p.soon ? 'Coming soon' : money(p.price) + (p.compareAt ? ' <small>' + money(p.compareAt) + '</small>' : '')) + '</div>';
    var action = p.soon ? '<a class="btn ghost lg block" href="/pages/community">Join the waitlist</a>' : '<button class="btn mint lg block" data-add data-id="' + p.id + '">Add to cart — ' + money(p.price) + '</button>';
    var viewFull = (p.url && p.url !== '#') ? '<a class="btn ghost block" href="' + p.url + '">View full details</a>' : '';
    qv.querySelector('.qv-info').innerHTML = '<span class="tier">' + p.tier + '</span><h3>' + p.title + '</h3>' + ratingLine + '<p class="qvp">' + p.blurb + '</p>' + priceLine + '<div class="qv-actions">' + action + viewFull + '</div>';
    wireAdd(qv.querySelector('.qv-info'));
    var addb = qv.querySelector('.qv-info [data-add]');
    if (addb) addb.addEventListener('click', function () { setTimeout(closeQV, 160); });
    qv.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeQV() { var qv = $('.qv'); if (qv) { qv.classList.remove('open'); document.body.style.overflow = ''; } }

  /* ---------- multi-step breadcrumb popup (data first → email → personalized offer) ---------- */
  var POP_ANS = {};
  var POPQ = [
    { k: 'level', q: 'Where are you in your trading journey?', opts: ['Total beginner', 'A few months in', 'A year or more', 'I trade full-time'] },
    { k: 'focus', q: "What's your #1 focus right now?", opts: ['Learning the basics', 'Building discipline', 'Finding a strategy', 'Staying consistent'] }
  ];
  function popDots(i) {
    var total = POPQ.length + 1, s = '';
    for (var d = 0; d < total; d++) s += '<span class="' + (d <= i ? 'on' : '') + '"></span>';
    return '<div class="pop-prog">' + s + '</div>';
  }
  function recProduct() {
    var lvl = POP_ANS.level || '', f = POP_ANS.focus || '';
    if (f.indexOf('discipline') > -1) return DATA.byId('risk-toolkit');
    if (f.indexOf('strategy') > -1 || lvl.indexOf('full-time') > -1) return DATA.byId('starter-kit');
    return DATA.byId('journal');
  }
  function renderPopStep(body, i) {
    if (i < POPQ.length) {
      var q = POPQ[i];
      body.innerHTML = '<span class="eyebrow">A gift for you</span>' + popDots(i) +
        '<div class="pop-q">' + q.q + '</div><div class="pop-opts">' +
        q.opts.map(function (o) { return '<button class="pop-opt" data-opt="' + o + '">' + o + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>'; }).join('') +
        '</div>' + (i > 0 ? '<button class="pop-back">← back</button>' : '');
      $$('[data-opt]', body).forEach(function (b) { b.addEventListener('click', function () { POP_ANS[q.k] = b.getAttribute('data-opt'); renderPopStep(body, i + 1); }); });
    } else {
      body.innerHTML = '<span class="eyebrow">Last step</span>' + popDots(i) +
        '<div class="pop-q">Where should we send your offer?</div><p style="color:var(--muted);font-size:.92rem;margin-bottom:18px">Your personalized discount + a free lesson, straight to your inbox.</p>' +
        '<form data-pop><input type="email" placeholder="your@email.com" required aria-label="Email address"><button type="submit" class="btn mint lg block">Reveal my offer</button></form><button class="pop-back">← back</button>';
      body.querySelector('[data-pop]').addEventListener('submit', function (ev) { ev.preventDefault(); showPopOffer(body); });
    }
    var bk = body.querySelector('.pop-back');
    if (bk) bk.addEventListener('click', function () { renderPopStep(body, i - 1); });
  }
  function showPopOffer(body) {
    var p = recProduct();
    var url = (p && p.url && p.url !== '#') ? p.url : '/pages/shop';
    var name = p ? p.title : 'The Journal';
    body.innerHTML = '<div class="pop-offer"><span class="eyebrow center">You’re in \u{1F33F}</span>' +
      '<h3 style="margin:12px 0 6px">Here’s 15% off your first order.</h3>' +
      '<p style="color:var(--muted);font-size:.94rem">Based on your answers, we’d start you with <b style="color:var(--cream)">' + name + '</b>.</p>' +
      '<div class="pop-code">ANYE15 <button data-copy="ANYE15">Copy</button></div>' +
      '<a href="' + url + '" class="btn mint lg block">Shop ' + name + ' →</a>' +
      '<p class="pop-foot">Use the code at checkout · also sent to your inbox.</p></div>';
    var cb = body.querySelector('[data-copy]');
    if (cb) cb.addEventListener('click', function () { try { navigator.clipboard.writeText('ANYE15'); cb.textContent = 'Copied ✓'; } catch (e) { cb.textContent = 'ANYE15'; } });
  }
  function buildPopup() {
    if ($('.pop')) return;
    var el = document.createElement('div');
    el.className = 'pop';
    el.innerHTML = '<div class="pop-panel"><button class="pop-close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<div class="pop-art"><div class="crest"><b>Aé</b><span>A gift for you</span></div></div>' +
      '<div class="pop-body"></div></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('.pop-close')) closePopup(); });
    renderPopStep(el.querySelector('.pop-body'), 0);
  }
  function openPopup() {
    try { if (sessionStorage.getItem('anye-quiz')) return; } catch (e) {}
    buildPopup();
    $('.pop').classList.add('open');
    document.body.style.overflow = 'hidden';
    try { sessionStorage.setItem('anye-quiz', '1'); } catch (e) {}
  }
  function closePopup() { var p = $('.pop'); if (p) { p.classList.remove('open'); document.body.style.overflow = ''; } }
  function popSeen() { try { return !!sessionStorage.getItem('anye-quiz'); } catch (e) { return false; } }

  /* ---------- motion: count-up, particles, progress, parallax ---------- */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function animateCount(el) {
    var raw = el.getAttribute('data-cv') || el.textContent;
    el.setAttribute('data-cv', raw);
    var m = raw.match(/^([^\d]*)([\d][\d,\.]*)(.*)$/);
    if (!m) return;
    var pre = m[1], numStr = m[2], suf = m[3];
    var decimals = (numStr.split('.')[1] || '').length;
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(target)) return;
    function fmt(v) { var s = decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString(); return pre + s + suf; }
    if (REDUCED) { el.textContent = fmt(target); return; }
    var dur = 1200, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * e);
      if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target);
    }
    el.textContent = fmt(0); requestAnimationFrame(step);
  }
  function setupMotion() {
    if (!$('.scrollbar')) { var b = document.createElement('div'); b.className = 'scrollbar'; document.body.appendChild(b); }
    var counters = $$('.hero-meta .m b, .commstats .s b, .discord-stats .d b, .rev-score .big, .proof b');
    if (counters.length) {
      var co = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { animateCount(en.target); co.unobserve(en.target); } });
      }, { threshold: 0.6 });
      counters.forEach(function (c) { co.observe(c); });
    }
    if (REDUCED) return;
    var hb = $('.home-hero-bg');
    if (hb && !hb.__parts) {
      hb.__parts = true;
      for (var i = 0; i < 16; i++) {
        var p = document.createElement('span');
        p.className = 'particle';
        var size = 2 + Math.random() * 5;
        p.style.width = size + 'px'; p.style.height = size + 'px';
        p.style.left = (Math.random() * 100) + '%';
        p.style.animationDuration = (14 + Math.random() * 16) + 's';
        p.style.animationDelay = (-Math.random() * 22) + 's';
        hb.appendChild(p);
      }
    }
  }

  function initPreloader() {
    var pl = $('.preloader'); if (!pl) return;
    if (REDUCED) { pl.classList.add('done'); return; }
    try { sessionStorage.setItem('anye-intro', '1'); } catch (e) {}
    setTimeout(function () { pl.classList.add('done'); }, 1400);
  }
  function setupTilt() {
    if (REDUCED) return;
    $$('.pcard, .colcard').forEach(function (c) {
      if (c.__tilt) return; c.__tilt = true;
      c.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        var r = c.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        c.style.transition = 'transform .08s linear';
        c.style.transform = 'perspective(900px) rotateX(' + (-py * 5).toFixed(2) + 'deg) rotateY(' + (px * 6).toFixed(2) + 'deg) translateY(-4px)';
      });
      c.addEventListener('pointerleave', function () { c.style.transition = ''; c.style.transform = ''; });
    });
  }
  function setupMagnetic() {
    if (REDUCED) return;
    $$('.hero-cta .btn, .finalcta .btn').forEach(function (b) {
      if (b.__mag) return; b.__mag = true;
      b.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transition = 'transform .12s ease-out';
        b.style.transform = 'translate(' + (x * 9).toFixed(1) + 'px,' + (y * 7).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transition = ''; b.style.transform = ''; });
    });
  }

  /* ---------- social proof: rotating "just purchased" toasts ---------- */
  function setupSocialProof() {
    if (REDUCED) return;
    if (window.ANYE_LANDING) return; // landing pages stay distraction-free
    if (!document.querySelector('.home-hero, .pdp, #buybox-anchor, .shop-grid')) return; // only on selling pages
    var NAMES = ['Rachel','Jasmine','Daniela','Simone','Maya','Amara','Grace','Noor','Bianca','Leah','Priya','Tasha','Olivia','Renee','Chloe','Naomi','Sofia','Imani','Hannah','Yara'];
    var PLACES = ['Dallas, TX','Atlanta, GA','Toronto, CA','London, UK','Phoenix, AZ','Chicago, IL','Miami, FL','Austin, TX','Brooklyn, NY','Seattle, WA','Denver, CO','Charlotte, NC','San Diego, CA','Houston, TX','Nashville, TN'];
    var ITEMS = ['The Beginner’s Trading Journal', 'The Beginner’s Trading Journal', 'The Starter Kit'];
    var TIMES = ['a few minutes ago','12 minutes ago','27 minutes ago','about an hour ago','2 hours ago','earlier today'];
    function pick(a, seed) { return a[seed % a.length]; }
    var toast = document.createElement('div');
    toast.className = 'sp-toast';
    toast.setAttribute('role', 'status');
    document.body.appendChild(toast);
    var n = 0;
    function show() {
      n++;
      var name = pick(NAMES, (n * 7 + 3));
      var place = pick(PLACES, (n * 5 + 1));
      var item = pick(ITEMS, (n * 3));
      var time = pick(TIMES, (n * 11 + 2));
      toast.innerHTML =
        '<button class="sp-x" aria-label="Dismiss">×</button>' +
        '<div class="sp-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M5 13l4 4L19 7"/></svg></div>' +
        '<div class="sp-body"><b>' + name + ' in ' + place + '</b>' +
        '<span>purchased <i>' + item + '</i></span>' +
        '<time>' + time + ' · verified</time></div>';
      toast.querySelector('.sp-x').addEventListener('click', function () { toast.classList.remove('in'); clearTimeout(hideT); clearTimeout(loopT); });
      toast.classList.add('in');
      hideT = setTimeout(function () { toast.classList.remove('in'); }, 5200);
      loopT = setTimeout(show, 5200 + 9000 + Math.floor((n * 1337) % 7000)); // ~14-21s gap, deterministic
    }
    var hideT, loopT;
    loopT = setTimeout(show, 6000); // first one after 6s
  }

  /* ---------- boot ---------- */
  function boot() {
    buildCartDOM();
    buildLightbox();
    buildQV();
    renderCart();
    fillArtPlaceholders();
    renderHome();
    renderShopIndex();
    renderFeaturedRow();
    renderIndiGrid();
    renderIndicator();
    renderAcademy();
    renderArticle();
    renderQuiz();
    renderCollection();
    initInteractions();
    setupMotion();
    initPreloader();
    setupMagnetic();
    setupTilt();
    observeReveals();
    setupSocialProof();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
